import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';
import RoiArea from '@blade-sxp/task-management/components/roi-area.vue';
import VideoDrawer from '@blade/common/components/task-management/simple-drawer.vue';
// import { zoneList } from '@blade-sxp/task-management/interfaces/createTask';
let TabArea = class TabArea extends Vue {
    tabData;
    dataSource;
    directionConfig;
    activeTask;
    zoneId;
    rtspUrl;
    twinRoi;
    mapSource;
    slectValue;
    roiDisabled;
    areaActive = 0;
    buttonType = false;
    type = 'roiArea';
    // drawButtons = ['polygon', 'rect'];
    linesId = '';
    Atlas = [];
    getPolygonData(val) {
        this.Atlas = val;
        return val;
    }
    get tabWidth() {
        const len = this.tabData.length;
        return len > 2 ? `22.5%` : '33.33%';
    }
    mounted() {
        this.type = this.tabData?.[0].type || 'modelType';
    }
    noSelectDirection(e) {
        this.linesId = e;
    }
    goNext() {
        this.areaActive = this.areaActive + 1;
        this.type = this.tabData[this.areaActive].type;
        this.$emit('changeAreaActive', this.areaActive);
    }
    mapAddDevice(vertices) {
        this.$emit('mapAddDevice', vertices);
    }
    delectMapSource() {
        this.$emit('delectMapSource', []);
    }
    getMapPolygonData(atlas) {
        this.$emit('getMapPolygonData', atlas);
    }
    goPrevious(areaActive) {
        if (this.areaActive === 0)
            return;
        // 判断区域二折现状态，没完成就删除
        if (this.tabData[this.areaActive].type === 'lines') {
            if (this.Atlas.length < 2) {
                const dom = this.$refs.roiArea;
                dom.$refs.drawer.$refs.simpleDrawer.deleteGraph(this.linesId);
            }
        }
        if (areaActive === 0) {
            this.areaActive = areaActive;
        }
        else {
            this.areaActive = this.areaActive - 1;
        }
        this.type = this.tabData[this.areaActive].type;
        this.$emit('changeAreaActive', this.areaActive);
    }
    changeComplete(complete) {
        this.$emit('changeComplete', complete);
    }
};
__decorate([
    Prop({ default: () => [] })
], TabArea.prototype, "tabData", void 0);
__decorate([
    Prop()
], TabArea.prototype, "dataSource", void 0);
__decorate([
    Prop()
], TabArea.prototype, "directionConfig", void 0);
__decorate([
    Prop()
], TabArea.prototype, "activeTask", void 0);
__decorate([
    Prop()
], TabArea.prototype, "zoneId", void 0);
__decorate([
    Prop()
], TabArea.prototype, "rtspUrl", void 0);
__decorate([
    Prop()
], TabArea.prototype, "twinRoi", void 0);
__decorate([
    Prop()
], TabArea.prototype, "mapSource", void 0);
__decorate([
    Prop()
], TabArea.prototype, "slectValue", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], TabArea.prototype, "roiDisabled", void 0);
__decorate([
    Emit('getPolygonData')
], TabArea.prototype, "getPolygonData", null);
TabArea = __decorate([
    Component({
        name: 'TabArea',
        components: {
            RoiArea,
            VideoDrawer,
        },
        i18n: {
            messages: {
                en: {
                    roiArea: 'ROI Area',
                    next: 'Next',
                    previous: 'Previous',
                    selectCamera: 'please select a camera',
                },
                zh: {
                    roiArea: 'ROI 区域',
                    next: '下一步',
                    previous: '上一步',
                    selectCamera: '请选择摄像头',
                },
            },
        },
    })
], TabArea);
export default TabArea;
